import { render } from "./VirtualMachineBasics.vue?vue&type=template&id=e72e60fa&scoped=true"
import script from "./VirtualMachineBasics.vue?vue&type=script&lang=js"
export * from "./VirtualMachineBasics.vue?vue&type=script&lang=js"

import "./VirtualMachineBasics.vue?vue&type=style&index=0&id=e72e60fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72e60fa"]])

export default __exports__